export enum ToolCode {
  edit = 'edit',
  info = 'info',
  create = 'create',
  delete = 'delete',
  measure = 'measure',
  editGeometry = 'editGeometry',
}
